import React from "react";
import { JAPIPublicationLoader } from "../latestResearch/publications/JAPIPublicationLoader";
import { AutoCompleteSearchBox } from "../search/searchBar/AutoCompleteSearchBox";
import PillsBar from "../search/searchBar/PillsBar";
import { useSelector } from "react-redux";
import { prefsToMyResearchUrl } from "./my-research-api";
import { ResearchBreadcrumb } from "../../pages/latestResearch/publications/breadcrumb/Breadcrumb";
import { Redirect } from "react-router";
import { ViewLayout } from "../latestResearch/publications/ViewLayout";
import ErrorBoundary from "../../lib/ErrorBoundary";

export const MyResearch = () => {
  const { filter } = useSelector((state) => state.filter);

  return (
    <ErrorBoundary className="px-2">
      <header className="bg-light clearfix pb-1">
        <ResearchBreadcrumb />
        <AutoCompleteSearchBox />
        <PillsBar filter={filter} />
      </header>

      <JAPIPublicationLoader
        scrollToTop={false}
        render={(publications, _noop, data) => <ViewLayout publications={publications} data={data} />}
      />
    </ErrorBoundary>
  );
};

export const GotoMyResearch = () => <Redirect to={prefsToMyResearchUrl()} />; // adds QS filter
